export const CONTROL_COMMENTS_LABELS = {
  addInternalComment: 'Add internal comment',
  composerPlaceholder: 'Type an internal comment…',
} as const
